<script lang="ts">
	import BgVideoNextLessonOverlay from './BgVideoNextLessonOverlay.svelte';
	import type { Lesson } from '$lib/types/hygraph';
	import { goto } from '$app/navigation';

	import { classes } from '$lib/utils';
	import { getTranslate } from '@tolgee/svelte';
	const { t } = getTranslate();

	export let nextLesson: Lesson | null | undefined;
	export let additionalClass = '';
</script>

<div
	class={classes(
		'absolute h-full w-full flex justify-center items-center font-[Gilroy]',
		additionalClass
	)}
>
	<BgVideoNextLessonOverlay
		hasNextLesson={!!nextLesson}
		on:click={() => nextLesson?.slug && goto(nextLesson.slug)}
	/>
	<div class="p-6 grid grid-cols-12 z-0" on:click on:keypress>
		<h4 class="mb-2 text-[1.3vw] col-start-4 leading-normal pt-4 col-span-3 font-normal uppercase	">
			{nextLesson?.name}
		</h4>
	</div>
</div>
